import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom"; 
import axios from "axios";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CTA from "../components/cta";
function AboutUs()
{
   const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.ae";

  const currentUrl = window.location.href;
const [formData, setFormData] = useState({ 
  agent_name: "",
  agent_lname: "",
  agent_phone: "",
  agent_email: "" ,
  agent_address: "" 
});
const [errors, setErrors] = useState({}); 
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState("");
const [responseMsg, setResponseMsg] = useState("");
const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};
 const handleSubmit = async (e) => {
  e.preventDefault();

  setSuccess("");
 const validate = () => {
  let err = {};

  if (!formData.agent_name.trim()) {
    err.agent_name = "First Name is required";
  }
 if (!formData.agent_lname.trim()) {
    err.agent_lname = "Last Name is required";
  }
  if (!formData.agent_phone.trim()) {
    err.agent_phone = "Phone number is required";
  } else if (!/^[0-9+\s-]{7,15}$/.test(formData.agent_phone)) {
    err.agent_phone = "Invalid phone number";
  }

  if (!formData.agent_email) {
    err.agent_email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
    err.agent_email = "Invalid email address";
  }
 

  setErrors(err);

  return Object.keys(err).length === 0;
};
  if (!validate()) return;

  setLoading(true);

  try {
    const payload = { 
      proref: "Contact Form",
      current_url: window.location.href,
      ...formData
    };

    const res = await axios.post(`${API}/api/EnquiryHandlerStatic.ashx`,
      JSON.stringify(payload),
      {
        headers: { "Content-Type": "application/json" }
      }
    );

   
setResponseMsg(res.data?.message || "Message sent successfully!");
    // reset form
    setFormData({ 
      agent_name: "",
      agent_lname: "",
      agent_phone: "",
      agent_email: "",
      agent_address: ""
    });

  } catch (err) {
    setResponseMsg("Something went wrong!");
  } finally {
    setLoading(false);
  }
}; 
    return(
       <>
 <section
                    className="flat-title-page innerbanner mrg-0 boder-r-0 pdg-btm-60"
                    style={{ backgroundImage: "url(images/inner-banner/about-us.jpg)" }}
                  >
                    <div className="container">
                      <div className="breadcrumb-content">
                        <h1 className="text-center text-white title">Our Story</h1>
                        <ul className="breadcrumb">
                          <li>
                            <Link to="/" className="text-white">
                              Home
                            </Link>
                          </li>
                          <li className="text-white">/ About Us</li>
                          <li className="text-white">/ Our Story</li>
                        </ul>
                      </div>
                    </div>
                  </section> 
  <section className="flat-section agnts">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="content-left img-animation wow">
          <img
            className="lazyload"
            src="assets/images/why.webp"
            alt=""
            style={{ borderRadius: 10 }}
          />
        </div>
        <div className="content-right">
          <div className="box-title wow fadeInUp">
            <div className="text-subtitle text-primary">About us</div>
            <h3 className="title mt-4">
              {" "}
              Welcome to Nova Vision real estate agency{" "}
            </h3>
            <p className="desc">
              {" "}
              At NV Real Estate, we specialize in connecting clients with their
              dream properties in Abu Dhabi and beyond. Whether you are looking
              for commercial real estate, a house for sale, or simply exploring
              the latest in property trends, we offer unparalleled expertise to
              guide your investment journey.{" "}
            </p>
            <p className="desc">
              {" "}
              Our services cater to both local and international markets, with a
              focus on ensuring our clients find the perfect space. From
              residential homes to commercial properties, our listings are
              carefully curated to meet diverse needs, providing you with
              options that suit your unique lifestyle.{" "}
            </p>
          </div>
          <div className="cnts">
            <div className="row">
              {/* 1: Simple counter */}
              <div className="col-md-4">
                <div className="card">
                  <div
                    className="number"
                    role="status"
                    aria-live="polite"
                    data-target={500}
                  >
                    <span>+</span>500
                  </div>
                  <div className="label">Projects Sold</div>
                </div>
              </div>
              {/* 2: Formatted with commas */}
              <div className="col-md-4">
                <div className="card">
                  <div
                    className="number"
                    role="status"
                    aria-live="polite"
                    data-target={7}
                  >
                    <span>+</span>7
                  </div>
                  <div className="label">Years of Experience</div>
                </div>
              </div>
              {/* 3: Starts when scrolled into view */}
              <div className="col-md-4">
                <div className="card">
                  <div
                    className="number"
                    role="status"
                    aria-live="polite"
                    data-target={50}
                  >
                    <span>+</span>50
                  </div>
                  <div className="label">Real Estate Agents</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Testimonial */}
  {/* End Testimonial */}
  <section className="contact-section" style={{ background: "#eee" }}>
    <div className="contact-container">
      {/* Contact Info */}
      <div className="contact-info">
        <h2>Get in Touch</h2>
        <p>We’d love to hear from you. Reach out for any queries or support.</p>
        <div className="info-box">
          <span>📍</span>
          <span>Sama Tower - Office 406 Zayed The First St <br/>Al Danah - Zone 1 - Abu Dhabi - UAE</span>
        </div>
        <div className="info-box">
          <span>📞</span>
          <Link to="tel:+971 2 644 6368">+971 2 644 6368</Link>
        </div>
        <div className="info-box">
          <span>✉️</span>
          <Link to="mailto:info@nvrealestate.ae">info@nvrealestate.ae</Link>
        </div>
      </div>
      {/* Contact Form */}
      <div className="contact-form">
        <h2>Contact Form</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
<input
                  type="hidden"
                  name="proref"
                  id="proref"
                  className="input"
                  defaultValue="Contact Us: Get in Touch"
                  style={{ width: "100%" }}
                /> 
  {/* Row 1 */}
  <div className="form-row">
    <div className="ip-group">
      <input
        type="text"
        name="agent_name"
        value={formData.agent_name}
        onChange={handleChange}
        placeholder="First Name"
        className={`form-control ${errors.agent_name ? "input-error" : ""}`}
      />
      {errors.agent_name && <p className="error-text">{errors.agent_name}</p>}
    </div>

    <div className="ip-group">
      <input
        type="text"
        name="agent_lname"
        value={formData.agent_lname}
        onChange={handleChange}
        placeholder="Last Name"
        className={`form-control ${errors.agent_lname ? "input-error" : ""}`}
      />
      {errors.agent_lname && <p className="error-text">{errors.agent_lname}</p>}
    </div>
  </div>

  {/* Row 2 */}
  <div className="form-row">
    <div className="ip-group">
      <PhoneInput
        country={"ae"}
        value={formData.agent_phone}
        onChange={(phone) =>
          setFormData({ ...formData, agent_phone: phone })
        }
        inputClass="form-control phone-input"
        containerClass="phone-container"
        enableSearch={true}
        placeholder="Enter phone number"
      />
      {errors.agent_phone && <p className="error-text">{errors.agent_phone}</p>}
    </div>

    <div className="ip-group">
      <input
        type="email"
        name="agent_email"
        value={formData.agent_email}
        onChange={handleChange}
        placeholder="Email"
        className={`form-control ${errors.agent_email ? "input-error" : ""}`}
      />
      {errors.agent_email && <p className="error-text">{errors.agent_email}</p>}
    </div>
  </div>

  {/* Message */}
  <div className="ip-group">
    <textarea
      name="agent_address"
      rows={4}
      placeholder="Message"
      value={formData.agent_address}
      onChange={handleChange}
      className="form-control"
    /> 
  </div>

  {/* Response */}
  {responseMsg && <div className="success-text">{responseMsg}</div>}

  <button
    type="submit"
    className="tf-btn-1 btn-view primary hover-btn-view w-100"
    disabled={loading}
  >
    {loading ? "Sending..." : "Submit"}
  </button>
</form>
         
      </div>
    </div>
  </section>
  {/* Testimonial */}
  <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2241.1236132290996!2d54.35930582623172!3d24.483469019358008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e67bc4fd96c6f%3A0x4c4766edcd59e19d!2sNova%20Vision%20Real%20Estate%20LLC!5e0!3m2!1sen!2sin!4v1778233987291!5m2!1sen!2sin"
   width="100%"
  height={450}
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
<CTA/>
</>

    )
}
    export default AboutUs;